<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>Site Status</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="workflow_buttons" id="siteWorkflowButtons">
            <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
                <!-- <mat-button-toggle [ngClass]="{setup:isSetup()}" value="setup" [checked]="isSetup()" (click)="setSetup()">Setup <mat-icon>toc</mat-icon></mat-button-toggle>
                <mat-button-toggle [ngClass]="{active:isActive()}" value="active" [checked]="isActive()" (click)="setActive()">Active <mat-icon>pool</mat-icon></mat-button-toggle>
                <mat-button-toggle [ngClass]="{closed:isClosed()}" value="closed" [checked]="isClosed()" (click)="setClosed()">Closed <mat-icon>cancel_presentation</mat-icon></mat-button-toggle> -->

                <!-- VNEXT-1430: KLW - Removing checkbox -->
                <mat-button-toggle [ngClass]="{setup:isSetup()}" value="setup" (click)="setSetup()">Setup <mat-icon>toc</mat-icon></mat-button-toggle>
                <mat-button-toggle [ngClass]="{active:isActive()}" value="active" (click)="setActive()">Active <mat-icon>pool</mat-icon></mat-button-toggle>
                <mat-button-toggle [ngClass]="{closed:isClosed()}" value="closed" (click)="setClosed()">Closed <mat-icon>cancel_presentation</mat-icon></mat-button-toggle>
            </mat-button-toggle-group>
        </div>
        <div><strong>Current State: <span class="current_status_{{site.currentStatus}}">{{site.currentStatus}}</span></strong></div>
        <div *ngIf="site.statuses.length > 0">
            <table class="wotkflow_history">
                <thead>
                    <tr><th>Workflow State</th><th>Set on</th></tr>
                </thead>
                <tbody>
                    <tr *ngFor="let wf of site.statuses">
                        <td>{{wf.status}}</td>
                        <td>{{wf.createdDate | date: 'medium'}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </mat-card-content>
</mat-card>
